var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 14.5833H10.0087M6.83366 18.3333H13.167C14.1004 18.3333 14.5671 18.3333 14.9236 18.1517C15.2372 17.9919 15.4922 17.7369 15.652 17.4233C15.8337 17.0668 15.8337 16.6001 15.8337 15.6667V4.33333C15.8337 3.39991 15.8337 2.9332 15.652 2.57668C15.4922 2.26308 15.2372 2.00811 14.9236 1.84832C14.5671 1.66666 14.1004 1.66666 13.167 1.66666H6.83366C5.90024 1.66666 5.43353 1.66666 5.07701 1.84832C4.7634 2.00811 4.50844 2.26308 4.34865 2.57668C4.16699 2.9332 4.16699 3.39991 4.16699 4.33333V15.6667C4.16699 16.6001 4.16699 17.0668 4.34865 17.4233C4.50844 17.7369 4.7634 17.9919 5.07701 18.1517C5.43353 18.3333 5.90024 18.3333 6.83366 18.3333ZM10.417 14.5833C10.417 14.8135 10.2304 15 10.0003 15C9.77021 15 9.58366 14.8135 9.58366 14.5833C9.58366 14.3532 9.77021 14.1667 10.0003 14.1667C10.2304 14.1667 10.417 14.3532 10.417 14.5833Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneLock);
export default __webpack_public_path__ + "static/media/phone-lock.64edee3e75326cc4ca5be1ae0fde6f7b.svg";
export { ForwardRef as ReactComponent };